<ng-template #id (click)="onDebug()"></ng-template>